import { useContext } from "react";
import { Icon } from "@iconify/react";
import { TextsContext } from "context/textsContext";
import DialogComponent from "components/DialogComponent";
import { ParagraphComponent } from "components/ParagraphComponent";

/**
 * Aviso de que un plan favorito guardado ya no es cotizable tal cual está: al
 * revalidarlo contra `/rate-engine/compute` (ver
 * helpers/FavoritePlanValidation.js), algún beneficio seleccionado resultó
 * obsoleto para el catálogo vigente. Es sólo informativo - el estado no se
 * sanea ni se usa/carga, hay que editar el plan antes de poder usarlo.
 *
 * Con `onCancel` se comporta como confirmar/cancelar; sin él, DialogComponent
 * infiere un solo botón de cierre.
 */
const StaleFavoritePlanWarningModal = ({
    show,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
}) => {
    const { texts } = useContext(TextsContext);

    return (
        <DialogComponent
            show={show}
            onClose={onCancel ?? onConfirm}
            onCancel={onCancel}
            onConfirm={onConfirm}
            cancelText={cancelText ?? (texts?.general_cancel_button ?? 'Cancel')}
            confirmText={confirmText ?? (texts?.fav_plan_stale_benefits_acknowledge ?? 'OK')}
        >
            <Icon icon="fluent:alert-12-regular" width={40} height={40} style={{ color: '#F12B24' }} className="mb-3" />
            <ParagraphComponent styleGroup="raleway color_primary mb-0">
                {texts?.fav_plan_stale_benefits_message_generic
                    ?? 'Some benefits in this plan are no longer available. Please edit the plan before using it.'}
            </ParagraphComponent>
        </DialogComponent>
    );
};

export default StaleFavoritePlanWarningModal;
